module.exports = __webpack_public_path__ + "static/map-0671cc280f1f8260427961505a8fc805.png";